// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Guest Gallery Styles - Scoped to .guest-gallery-page */

.guest-gallery-page {
    background-color: var(--bg-white);
    overflow-x: hidden;
    font-family: var(--font-outfit), sans-serif;
}

/* Hide navbar toggler on guest gallery page */
.guest-gallery-page .navbar-toggler {
    display: none !important;
}

.guest-gallery-page .sparkle-image {
    position: absolute;
    right: 150px;
    top: 200px
}

/* Header / Hero Section */
.guest-gallery-page .header-gradient {
    background: linear-gradient(90deg, var(--primary-color) 0%, var(--primary-color) 25%, var(--secondary-color) 100%);
    border-radius: 0 0 250px 0;
    min-height: 800px;
    position: relative;
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    align-items: flex-start;
}

.guest-gallery-page .carousel-section {
    padding: 176px 70px 0px 100px;
    /* display: flex; */
    align-items: center;
    width: 100%;
}

.guest-gallery-page .guest-hero-title {
    font-size: 3.75rem;
    font-size: var(--font-size-xxxxlarge);
    font-family: var(--font-codec-cold);
    font-weight: var(--font-bold);
    color: var(--text-white);
    line-height: 1.15;
    letter-spacing: -0.02em;
    margin-bottom: 1.5rem;
}

.guest-gallery-page .guest-hero-title span {
    color: var(--secondary-color);
    background: linear-gradient(to right, #fff, #e0e0e0);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-style: italic;
    padding-right: 0.2em;
}

.guest-gallery-page .guest-hero-subtitle {
    font-size: 1.25rem;
    font-size: var(--font-size-large);
    font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 2.5rem;
    line-height: 1.6;
    max-width: 600px;
}

.guest-gallery-page .guest-hero-subtitle span {
    font-weight: 600;
    color: #fff;
    display: block;
    margin-top: 0.5rem;
}

.guest-gallery-page .guest-logo-container {
    background: rgba(255, 255, 255, 0.95);
    padding: 12px 30px;
    border-radius: 100px;
    display: inline-block;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    margin-bottom: 2rem;
}

.guest-gallery-page .hero-actions .btn {
    padding: 14px 36px;
    font-weight: 600;
    border-radius: 50px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 1rem;
    letter-spacing: 0.5px;
}

.guest-gallery-page .btn-secondary {
    background-color: var(--bg-white) !important;
    color: var(--text-primary) !important;
    border-radius: 40px;
    padding: 8px 20px;
    font-size: var(--font-size-small);
    font-weight: var(--font-medium);
    border: none;
    transition: all 0.3s ease;
    display: inline-block;
    width: fit-content;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.guest-gallery-page .btn-secondary:hover {
    background-color: var(--bg-white) !important;
    color: var(--text-primary) !important;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.guest-gallery-page .btn-outline-white {
    border: 2px solid rgba(255, 255, 255, 0.8) !important;
    color: white !important;
    background: transparent;
}

.guest-gallery-page .btn-outline-white:hover {
    background: rgba(255, 255, 255, 0.1) !important;
    border-color: white !important;
    transform: translateY(-2px);
}

.guest-gallery-page .header-image-anim {
    position: absolute;
    bottom: 0;
    right: 200px;
}

.guest-gallery-page .carousel-container {
    position: relative;
    transition: opacity 0.5s ease-in-out;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.guest-gallery-page .carousel-container.fade-in {
    opacity: 1;
}

.guest-gallery-page .carousel-container.fade-out {
    opacity: 0;
}

.guest-gallery-page .carousel-image {
    width: 500px;
    max-width: 100%;
    height: auto;
    display: block;
    filter: drop-shadow(0 20px 50px rgba(0, 0, 0, 0.2));
    transition: transform 0.5s ease-out;
}

/* Steps Section */
.guest-gallery-page .steps-section {
    padding: 50px 0 0 0;
    background-color: #fff;
    position: relative;
    z-index: 2;
}

.guest-gallery-page .process-steps-container {
    padding: 0px 0;
    /* background-image: url('../../../../public/assets/img/website/bg-curve-line.svg'); */
    /* background-size: contain;
    background-position: center bottom;
    background-repeat: no-repeat; */
}

.guest-gallery-page .step-item {
    padding: 20px;
    transition: transform 0.3s ease;
}

.guest-gallery-page .step-item:hover {
    transform: translateY(-5px);
}

.guest-gallery-page .step-image {
    min-height: 152px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: 30px;
}

.guest-gallery-page .step-image img {
    max-width: 220px;
    max-height: 220px;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));
}

.guest-gallery-page .step-item:hover .step-image img {
    transform: scale(1.1) rotate(2deg);
}

.guest-gallery-page .step-info .step-number {
    font-size: 1.2rem;
    font-weight: 900;
    color: var(--text-black);
    display: block;
    line-height: 1;
    margin-bottom: 15px;
    position: relative;
    z-index: 0;
}

.guest-gallery-page .step-info h4 {
    font-size: 1.2rem;
    margin-bottom: 12px;
    position: relative;
    z-index: 1;
    font-weight: var(--font-bold);
    color: var(--text-primary);
    font-family: var(--font-codec-cold);
    margin-top: 10px;
}

.guest-gallery-page .step-info p {
    font-size: var(--font-size-small);
    color: var(--text-black);
    line-height: 1.6;
    position: relative;
    z-index: 1;
}

/* Sample Sections & Info Cards */
.guest-gallery-page .guest-samples-section {
    padding: 40px 0;
}

.guest-gallery-page .guest-samples-section.bg-linear-gradient {
    background: linear-gradient(180deg, #F9FAFB 0%, #F3F4F6 100%);
}

.guest-gallery-page .section-header {
    max-width: 800px;
    margin: 0 auto 60px;
}

.guest-gallery-page .section-title {
    font-family: var(--font-codec-cold);
    font-size: 1.3rem;
    font-weight: 700;
    color: var(--text-black);
    letter-spacing: -0.01em;
    margin-bottom: 1rem;
}

.guest-gallery-page .section-description {
    font-size: var(--font-size-small);
    color: #666;
    font-family: var(--font-montserrat);
}

.guest-gallery-page .info-card {
    background: #FFFFFF;
    border-radius: 20px;
    padding: 0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
    border: 1px solid rgba(0, 0, 0, 0.04);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    height: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
}

.guest-gallery-page .info-card:hover {
    transform: translateY(-12px);
    box-shadow: 0 20px 40px -5px rgba(99, 24, 198, 0.15), 0 10px 20px -5px rgba(0, 0, 0, 0.04);
    border-color: rgba(99, 24, 198, 0.2);
}

.guest-gallery-page .sample-card-content {
    padding: 24px;
    text-align: left;
    background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
    flex-grow: 1;
    position: relative;
    z-index: 2;
}

.guest-gallery-page .sample-title {
    font-family: var(--font-codec-cold);
    font-weight: 700;
    font-size: 1.25rem;
    color: var(--text-black);
    margin-bottom: 0.75rem;
    letter-spacing: -0.01em;
}

.guest-gallery-page .sample-title::after {
    content: '';
    display: block;
    width: 40px;
    height: 2px;
    background: linear-gradient(90deg, var(--secondary-color), transparent);
    margin-top: 8px;
    border-radius: 2px;
}

.guest-gallery-page .sample-description {
    font-size: 0.95rem;
    color: #52525B;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.6;
    font-weight: 400;
}

/* CTA Section */
.guest-gallery-page .guest-cta-section {
    padding: 140px 0;
    background: linear-gradient(135deg, var(--primary-color) 0%, #7C3AED 100%) !important;
    color: white !important;
    text-align: center;
}

.guest-gallery-page .cta-title {
    font-family: var(--font-codec-cold);
    font-size: 2.5rem;
    font-weight: 700;
    color: #ffffff !important;
    margin-bottom: 1.5rem;
}

.guest-gallery-page .cta-description {
    font-size: 1.3rem;
    color: rgba(255, 255, 255, 0.9) !important;
    max-width: 700px;
    margin: 0 auto 3rem;
}

.guest-gallery-page .btn-primary {
    background-color: white !important;
    color: var(--primary-color) !important;
    padding: 16px 40px !important;
    font-size: 1.1rem !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.guest-gallery-page .btn-primary:hover {
    background-color: #f8f9fa !important;
    transform: translateY(-2px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}

.guest-gallery-page .btn-outline-primary {
    border: 2px solid rgba(255, 255, 255, 0.4) !important;
    color: white !important;
}

.guest-gallery-page .btn-outline-primary:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-color: white !important;
}

.guest-gallery-page .btn-cta-primary {
    background-color: white !important;
    color: var(--primary-color) !important;
    padding: 16px 40px !important;
    font-size: 1.1rem !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    border: none !important;
    border-radius: 50px !important;
    font-weight: 700 !important;
}

.guest-gallery-page .btn-cta-primary:hover {
    background-color: #f8f9fa !important;
    transform: translateY(-2px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
    color: #4c1d95 !important;
}

.guest-gallery-page .btn-cta-outline {
    background-color: transparent !important;
    border: 2px solid rgba(255, 255, 255, 0.4) !important;
    color: white !important;
    padding: 16px 40px !important;
    font-size: 1.1rem !important;
    border-radius: 50px !important;
    font-weight: 600 !important;
}

.guest-gallery-page .btn-cta-outline:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-color: white !important;
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* Dialog Styles */
.guest-gallery-page .preview-dialog .MuiDialog-paper {
    background: transparent;
    box-shadow: none;
    overflow: visible;
    max-width: 900px;
}

.guest-gallery-page .preview-media {
    border-radius: 20px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    max-height: 85vh;
}

.guest-gallery-page .close-button {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    width: 44px;
    height: 44px;
    top: -20px;
    right: -20px;
}

.guest-gallery-page .close-button:hover {
    background: rgba(255, 255, 255, 0.3);
}

/* Footer Simplification */
.guest-gallery-page .guest-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
}

/* Responsive Overrides */
@media (max-width: 1200px) {
    .guest-gallery-page .guest-hero-title {
        font-size: 3rem;
    }

    .guest-gallery-page .carousel-image {
        width: 100%;
        max-width: 600px;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .guest-gallery-page .carousel-section {
        padding: 160px 50px 0px 50px !important;
    }

    .guest-gallery-page .guest-hero-title {
        font-size: var(--font-size-xxxlarge);
        margin-bottom: 11px;
    }

    .guest-gallery-page .section-content {
        padding: 5px 0px 0 0px;
    }

    .guest-gallery-page .guest-hero-subtitle {
        font-size: var(--font-size-medium);
    }

    .guest-gallery-page .header-gradient {
        min-height: 59vh;
        border-radius: 0 0 35px 0;
    }

    .guest-gallery-page .header-image-anim img,
    .guest-gallery-page .carousel-image {
        width: 278px !important;
    }

    .guest-gallery-page .header-image-anim {
        position: absolute;
        bottom: 0;
        right: 20px;
    }

    .guest-gallery-page .sparkle-image {
        left: 257px;
        bottom: 21px;
        right: inherit !important;
        top: inherit !important;
        width: 123px;
    }
}

@media (max-width: 767px) {
    .guest-gallery-page .carousel-section {
        padding: 114px 15px 0px 15px !important;
    }

    .guest-gallery-page .guest-hero-title {
        font-size: var(--font-size-large);
        margin-bottom: 11px;
    }

    .guest-gallery-page .section-content {
        padding: 5px 0px 0 0px;
    }

    .guest-gallery-page .guest-hero-subtitle {
        font-size: var(--font-x-size-small);
    }

    .guest-gallery-page .header-gradient {
        min-height: 71vh !important;
        border-radius: 0 0 35px 0 !important;
        padding-bottom: 60px !important;
        overflow: hidden !important;
    }

    .guest-gallery-page .header-image-anim {
        position: absolute !important;
        bottom: 0 !important;
        right: 20px !important;
    }

    .guest-gallery-page .header-image-anim img,
    .guest-gallery-page .carousel-image {
        width: 170px !important;
        height: auto !important;
    }

    .guest-gallery-page .sparkle-image {
        left: 41px !important;
        bottom: 21px !important;
        right: inherit !important;
        top: inherit !important;
        width: 60px !important;
        display: block !important;
    }
}

@media (max-width: 576px) {
    .guest-gallery-page .guest-hero-title {
        font-size: var(--font-size-large);
        margin-bottom: 11px;
    }

    .guest-gallery-page .guest-hero-subtitle {
        font-size: var(--font-x-size-small);
    }

    .guest-gallery-page .sparkle-image {
        left: 41px !important;
        bottom: 21px !important;
        right: inherit !important;
        top: inherit !important;
        width: 60px !important;
    }

    .guest-gallery-page .header-image-anim img,
    .guest-gallery-page .carousel-image {
        width: 190px !important;
    }

    .guest-gallery-page .header-image-anim {
        position: absolute !important;
        bottom: 0 !important;
        right: 20px !important;
    }
}

.font-heading-guest {
    font-size: 22px;
    font-weight: var(--font-bold);
    line-height: 1.4;
    color: var(--text-primary);
    margin-bottom: 15px;
    font-family: var(--font-codec-cold);
}

@media (max-width: 414px) {
    .guest-gallery-page .guest-hero-title {
        font-size: var(--font-size-xlarge);
        margin-bottom: 11px;
    }

    .guest-gallery-page .guest-hero-subtitle {
        font-size: var(--font-size-small);
    }

    .guest-gallery-page .sparkle-image {
        left: 41px !important;
        bottom: 21px !important;
        right: inherit !important;
        top: inherit !important;
        width: 60px !important;
    }

    .guest-gallery-page .header-image-anim img,
    .guest-gallery-page .carousel-image {
        width: 175px !important;
    }

    .guest-gallery-page .header-image-anim {
        position: absolute !important;
        bottom: 0 !important;
        right: 20px !important;
    }
}

@media (max-width: 375px) {
    .guest-gallery-page .guest-hero-title {
        font-size: var(--font-size-large);
        margin-bottom: 11px;
    }

    .guest-gallery-page .guest-hero-subtitle {
        font-size: var(--font-x-size-small);
    }

    .guest-gallery-page .sparkle-image {
        left: 41px !important;
        bottom: 21px !important;
        right: inherit !important;
        top: inherit !important;
        width: 60px !important;
    }

    .guest-gallery-page .header-image-anim img,
    .guest-gallery-page .carousel-image {
        width: 200px !important;
    }

    .guest-gallery-page .header-image-anim {
        position: absolute !important;
        bottom: 0 !important;
        right: 20px !important;
    }
}

@media (max-width: 360px) {
    .guest-gallery-page .guest-hero-title {
        font-size: var(--font-size-large);
        margin-bottom: 11px;
    }

    .guest-gallery-page .guest-hero-subtitle {
        font-size: var(--font-x-size-small);
    }

    .guest-gallery-page .sparkle-image {
        left: 41px !important;
        bottom: 21px !important;
        right: inherit !important;
        top: inherit !important;
        width: 60px !important;
    }

    .guest-gallery-page .header-image-anim img,
    .guest-gallery-page .carousel-image {
        width: 162px !important;
    }

    .guest-gallery-page .header-image-anim {
        position: absolute !important;
        bottom: 0 !important;
        right: 20px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Merchant/Guest/GuestGallery.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;IACI,iCAAiC;IACjC,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA,8CAA8C;AAC9C;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA,0BAA0B;AAC1B;IACI,kHAAkH;IAClH,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mCAAmC;IACnC,6BAA6B;IAC7B,wBAAwB;IACxB,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,oDAAoD;IACpD,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,0CAA0C;IAC1C,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iDAAiD;IACjD,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;IACjC,+BAA+B;IAC/B,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,qDAAqD;IACrD,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mDAAmD;IACnD,mCAAmC;AACvC;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,sFAAsF;IACtF;;mCAE+B;AACnC;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4DAA4D;IAC5D,mDAAmD;AACvD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,6BAA6B;IAC7B,0BAA0B;IAC1B,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA,iCAAiC;AACjC;IACI,eAAe;AACnB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,kFAAkF;IAClF,qCAAqC;IACrC,4DAA4D;IAC5D,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,0FAA0F;IAC1F,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gEAAgE;IAChE,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,uEAAuE;IACvE,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,qFAAqF;IACrF,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,0CAA0C;IAC1C,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,sCAAsC;IACtC,6BAA6B;IAC7B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,qDAAqD;IACrD,uBAAuB;AAC3B;;AAEA;IACI,qDAAqD;IACrD,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,sCAAsC;IACtC,6BAA6B;IAC7B,4BAA4B;IAC5B,0CAA0C;IAC1C,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,qDAAqD;IACrD,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,qDAAqD;IACrD,8BAA8B;IAC9B,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,0BAA0B;AAC1B;IACI,yCAAyC;AAC7C;;AAEA,yBAAyB;AACzB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,uCAAuC;IAC3C;;IAEA;QACI,oCAAoC;QACpC,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,uBAAuB;QACvB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,uCAAuC;IAC3C;;IAEA;QACI,iCAAiC;QACjC,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,2BAA2B;QAC3B,oCAAoC;QACpC,+BAA+B;QAC/B,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;;QAEI,uBAAuB;QACvB,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,yBAAyB;QACzB,uBAAuB;QACvB,sBAAsB;QACtB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,mBAAmB;IACvB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,yBAAyB;QACzB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI;QACI,kCAAkC;QAClC,mBAAmB;IACvB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,yBAAyB;QACzB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,mBAAmB;IACvB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,yBAAyB;QACzB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,mBAAmB;IACvB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,yBAAyB;QACzB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,sBAAsB;IAC1B;AACJ","sourcesContent":["/* Guest Gallery Styles - Scoped to .guest-gallery-page */\n\n.guest-gallery-page {\n    background-color: var(--bg-white);\n    overflow-x: hidden;\n    font-family: var(--font-outfit), sans-serif;\n}\n\n/* Hide navbar toggler on guest gallery page */\n.guest-gallery-page .navbar-toggler {\n    display: none !important;\n}\n\n.guest-gallery-page .sparkle-image {\n    position: absolute;\n    right: 150px;\n    top: 200px\n}\n\n/* Header / Hero Section */\n.guest-gallery-page .header-gradient {\n    background: linear-gradient(90deg, var(--primary-color) 0%, var(--primary-color) 25%, var(--secondary-color) 100%);\n    border-radius: 0 0 250px 0;\n    min-height: 800px;\n    position: relative;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex;\n    align-items: flex-start;\n}\n\n.guest-gallery-page .carousel-section {\n    padding: 176px 70px 0px 100px;\n    /* display: flex; */\n    align-items: center;\n    width: 100%;\n}\n\n.guest-gallery-page .guest-hero-title {\n    font-size: 3.75rem;\n    font-size: var(--font-size-xxxxlarge);\n    font-family: var(--font-codec-cold);\n    font-weight: var(--font-bold);\n    color: var(--text-white);\n    line-height: 1.15;\n    letter-spacing: -0.02em;\n    margin-bottom: 1.5rem;\n}\n\n.guest-gallery-page .guest-hero-title span {\n    color: var(--secondary-color);\n    background: linear-gradient(to right, #fff, #e0e0e0);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-style: italic;\n    padding-right: 0.2em;\n}\n\n.guest-gallery-page .guest-hero-subtitle {\n    font-size: 1.25rem;\n    font-size: var(--font-size-large);\n    font-weight: 400;\n    color: rgba(255, 255, 255, 0.9);\n    margin-bottom: 2.5rem;\n    line-height: 1.6;\n    max-width: 600px;\n}\n\n.guest-gallery-page .guest-hero-subtitle span {\n    font-weight: 600;\n    color: #fff;\n    display: block;\n    margin-top: 0.5rem;\n}\n\n.guest-gallery-page .guest-logo-container {\n    background: rgba(255, 255, 255, 0.95);\n    padding: 12px 30px;\n    border-radius: 100px;\n    display: inline-block;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(10px);\n    margin-bottom: 2rem;\n}\n\n.guest-gallery-page .hero-actions .btn {\n    padding: 14px 36px;\n    font-weight: 600;\n    border-radius: 50px;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    font-size: 1rem;\n    letter-spacing: 0.5px;\n}\n\n.guest-gallery-page .btn-secondary {\n    background-color: var(--bg-white) !important;\n    color: var(--text-primary) !important;\n    border-radius: 40px;\n    padding: 8px 20px;\n    font-size: var(--font-size-small);\n    font-weight: var(--font-medium);\n    border: none;\n    transition: all 0.3s ease;\n    display: inline-block;\n    width: fit-content;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.guest-gallery-page .btn-secondary:hover {\n    background-color: var(--bg-white) !important;\n    color: var(--text-primary) !important;\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n}\n\n.guest-gallery-page .btn-outline-white {\n    border: 2px solid rgba(255, 255, 255, 0.8) !important;\n    color: white !important;\n    background: transparent;\n}\n\n.guest-gallery-page .btn-outline-white:hover {\n    background: rgba(255, 255, 255, 0.1) !important;\n    border-color: white !important;\n    transform: translateY(-2px);\n}\n\n.guest-gallery-page .header-image-anim {\n    position: absolute;\n    bottom: 0;\n    right: 200px;\n}\n\n.guest-gallery-page .carousel-container {\n    position: relative;\n    transition: opacity 0.5s ease-in-out;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.guest-gallery-page .carousel-container.fade-in {\n    opacity: 1;\n}\n\n.guest-gallery-page .carousel-container.fade-out {\n    opacity: 0;\n}\n\n.guest-gallery-page .carousel-image {\n    width: 500px;\n    max-width: 100%;\n    height: auto;\n    display: block;\n    filter: drop-shadow(0 20px 50px rgba(0, 0, 0, 0.2));\n    transition: transform 0.5s ease-out;\n}\n\n/* Steps Section */\n.guest-gallery-page .steps-section {\n    padding: 50px 0 0 0;\n    background-color: #fff;\n    position: relative;\n    z-index: 2;\n}\n\n.guest-gallery-page .process-steps-container {\n    padding: 0px 0;\n    /* background-image: url('../../../../public/assets/img/website/bg-curve-line.svg'); */\n    /* background-size: contain;\n    background-position: center bottom;\n    background-repeat: no-repeat; */\n}\n\n.guest-gallery-page .step-item {\n    padding: 20px;\n    transition: transform 0.3s ease;\n}\n\n.guest-gallery-page .step-item:hover {\n    transform: translateY(-5px);\n}\n\n.guest-gallery-page .step-image {\n    min-height: 152px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    margin-bottom: 30px;\n}\n\n.guest-gallery-page .step-image img {\n    max-width: 220px;\n    max-height: 220px;\n    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));\n}\n\n.guest-gallery-page .step-item:hover .step-image img {\n    transform: scale(1.1) rotate(2deg);\n}\n\n.guest-gallery-page .step-info .step-number {\n    font-size: 1.2rem;\n    font-weight: 900;\n    color: var(--text-black);\n    display: block;\n    line-height: 1;\n    margin-bottom: 15px;\n    position: relative;\n    z-index: 0;\n}\n\n.guest-gallery-page .step-info h4 {\n    font-size: 1.2rem;\n    margin-bottom: 12px;\n    position: relative;\n    z-index: 1;\n    font-weight: var(--font-bold);\n    color: var(--text-primary);\n    font-family: var(--font-codec-cold);\n    margin-top: 10px;\n}\n\n.guest-gallery-page .step-info p {\n    font-size: var(--font-size-small);\n    color: var(--text-black);\n    line-height: 1.6;\n    position: relative;\n    z-index: 1;\n}\n\n/* Sample Sections & Info Cards */\n.guest-gallery-page .guest-samples-section {\n    padding: 40px 0;\n}\n\n.guest-gallery-page .guest-samples-section.bg-linear-gradient {\n    background: linear-gradient(180deg, #F9FAFB 0%, #F3F4F6 100%);\n}\n\n.guest-gallery-page .section-header {\n    max-width: 800px;\n    margin: 0 auto 60px;\n}\n\n.guest-gallery-page .section-title {\n    font-family: var(--font-codec-cold);\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: var(--text-black);\n    letter-spacing: -0.01em;\n    margin-bottom: 1rem;\n}\n\n.guest-gallery-page .section-description {\n    font-size: var(--font-size-small);\n    color: #666;\n    font-family: var(--font-montserrat);\n}\n\n.guest-gallery-page .info-card {\n    background: #FFFFFF;\n    border-radius: 20px;\n    padding: 0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n\n.guest-gallery-page .info-card:hover {\n    transform: translateY(-12px);\n    box-shadow: 0 20px 40px -5px rgba(99, 24, 198, 0.15), 0 10px 20px -5px rgba(0, 0, 0, 0.04);\n    border-color: rgba(99, 24, 198, 0.2);\n}\n\n.guest-gallery-page .sample-card-content {\n    padding: 24px;\n    text-align: left;\n    background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);\n    flex-grow: 1;\n    position: relative;\n    z-index: 2;\n}\n\n.guest-gallery-page .sample-title {\n    font-family: var(--font-codec-cold);\n    font-weight: 700;\n    font-size: 1.25rem;\n    color: var(--text-black);\n    margin-bottom: 0.75rem;\n    letter-spacing: -0.01em;\n}\n\n.guest-gallery-page .sample-title::after {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 2px;\n    background: linear-gradient(90deg, var(--secondary-color), transparent);\n    margin-top: 8px;\n    border-radius: 2px;\n}\n\n.guest-gallery-page .sample-description {\n    font-size: 0.95rem;\n    color: #52525B;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    line-height: 1.6;\n    font-weight: 400;\n}\n\n/* CTA Section */\n.guest-gallery-page .guest-cta-section {\n    padding: 140px 0;\n    background: linear-gradient(135deg, var(--primary-color) 0%, #7C3AED 100%) !important;\n    color: white !important;\n    text-align: center;\n}\n\n.guest-gallery-page .cta-title {\n    font-family: var(--font-codec-cold);\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: #ffffff !important;\n    margin-bottom: 1.5rem;\n}\n\n.guest-gallery-page .cta-description {\n    font-size: 1.3rem;\n    color: rgba(255, 255, 255, 0.9) !important;\n    max-width: 700px;\n    margin: 0 auto 3rem;\n}\n\n.guest-gallery-page .btn-primary {\n    background-color: white !important;\n    color: var(--primary-color) !important;\n    padding: 16px 40px !important;\n    font-size: 1.1rem !important;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.guest-gallery-page .btn-primary:hover {\n    background-color: #f8f9fa !important;\n    transform: translateY(-2px);\n    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);\n}\n\n.guest-gallery-page .btn-outline-primary {\n    border: 2px solid rgba(255, 255, 255, 0.4) !important;\n    color: white !important;\n}\n\n.guest-gallery-page .btn-outline-primary:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n    border-color: white !important;\n}\n\n.guest-gallery-page .btn-cta-primary {\n    background-color: white !important;\n    color: var(--primary-color) !important;\n    padding: 16px 40px !important;\n    font-size: 1.1rem !important;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    border: none !important;\n    border-radius: 50px !important;\n    font-weight: 700 !important;\n}\n\n.guest-gallery-page .btn-cta-primary:hover {\n    background-color: #f8f9fa !important;\n    transform: translateY(-2px);\n    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);\n    color: #4c1d95 !important;\n}\n\n.guest-gallery-page .btn-cta-outline {\n    background-color: transparent !important;\n    border: 2px solid rgba(255, 255, 255, 0.4) !important;\n    color: white !important;\n    padding: 16px 40px !important;\n    font-size: 1.1rem !important;\n    border-radius: 50px !important;\n    font-weight: 600 !important;\n}\n\n.guest-gallery-page .btn-cta-outline:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n    border-color: white !important;\n    transform: translateY(-2px);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n/* Dialog Styles */\n.guest-gallery-page .preview-dialog .MuiDialog-paper {\n    background: transparent;\n    box-shadow: none;\n    overflow: visible;\n    max-width: 900px;\n}\n\n.guest-gallery-page .preview-media {\n    border-radius: 20px;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n    max-height: 85vh;\n}\n\n.guest-gallery-page .close-button {\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    width: 44px;\n    height: 44px;\n    top: -20px;\n    right: -20px;\n}\n\n.guest-gallery-page .close-button:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n/* Footer Simplification */\n.guest-gallery-page .guest-footer {\n    border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n/* Responsive Overrides */\n@media (max-width: 1200px) {\n    .guest-gallery-page .guest-hero-title {\n        font-size: 3rem;\n    }\n\n    .guest-gallery-page .carousel-image {\n        width: 100%;\n        max-width: 600px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n    .guest-gallery-page .carousel-section {\n        padding: 160px 50px 0px 50px !important;\n    }\n\n    .guest-gallery-page .guest-hero-title {\n        font-size: var(--font-size-xxxlarge);\n        margin-bottom: 11px;\n    }\n\n    .guest-gallery-page .section-content {\n        padding: 5px 0px 0 0px;\n    }\n\n    .guest-gallery-page .guest-hero-subtitle {\n        font-size: var(--font-size-medium);\n    }\n\n    .guest-gallery-page .header-gradient {\n        min-height: 59vh;\n        border-radius: 0 0 35px 0;\n    }\n\n    .guest-gallery-page .header-image-anim img,\n    .guest-gallery-page .carousel-image {\n        width: 278px !important;\n    }\n\n    .guest-gallery-page .header-image-anim {\n        position: absolute;\n        bottom: 0;\n        right: 20px;\n    }\n\n    .guest-gallery-page .sparkle-image {\n        left: 257px;\n        bottom: 21px;\n        right: inherit !important;\n        top: inherit !important;\n        width: 123px;\n    }\n}\n\n@media (max-width: 767px) {\n    .guest-gallery-page .carousel-section {\n        padding: 114px 15px 0px 15px !important;\n    }\n\n    .guest-gallery-page .guest-hero-title {\n        font-size: var(--font-size-large);\n        margin-bottom: 11px;\n    }\n\n    .guest-gallery-page .section-content {\n        padding: 5px 0px 0 0px;\n    }\n\n    .guest-gallery-page .guest-hero-subtitle {\n        font-size: var(--font-x-size-small);\n    }\n\n    .guest-gallery-page .header-gradient {\n        min-height: 71vh !important;\n        border-radius: 0 0 35px 0 !important;\n        padding-bottom: 60px !important;\n        overflow: hidden !important;\n    }\n\n    .guest-gallery-page .header-image-anim {\n        position: absolute !important;\n        bottom: 0 !important;\n        right: 20px !important;\n    }\n\n    .guest-gallery-page .header-image-anim img,\n    .guest-gallery-page .carousel-image {\n        width: 170px !important;\n        height: auto !important;\n    }\n\n    .guest-gallery-page .sparkle-image {\n        left: 41px !important;\n        bottom: 21px !important;\n        right: inherit !important;\n        top: inherit !important;\n        width: 60px !important;\n        display: block !important;\n    }\n}\n\n@media (max-width: 576px) {\n    .guest-gallery-page .guest-hero-title {\n        font-size: var(--font-size-large);\n        margin-bottom: 11px;\n    }\n\n    .guest-gallery-page .guest-hero-subtitle {\n        font-size: var(--font-x-size-small);\n    }\n\n    .guest-gallery-page .sparkle-image {\n        left: 41px !important;\n        bottom: 21px !important;\n        right: inherit !important;\n        top: inherit !important;\n        width: 60px !important;\n    }\n\n    .guest-gallery-page .header-image-anim img,\n    .guest-gallery-page .carousel-image {\n        width: 190px !important;\n    }\n\n    .guest-gallery-page .header-image-anim {\n        position: absolute !important;\n        bottom: 0 !important;\n        right: 20px !important;\n    }\n}\n\n.font-heading-guest {\n    font-size: 22px;\n    font-weight: var(--font-bold);\n    line-height: 1.4;\n    color: var(--text-primary);\n    margin-bottom: 15px;\n    font-family: var(--font-codec-cold);\n}\n\n@media (max-width: 414px) {\n    .guest-gallery-page .guest-hero-title {\n        font-size: var(--font-size-xlarge);\n        margin-bottom: 11px;\n    }\n\n    .guest-gallery-page .guest-hero-subtitle {\n        font-size: var(--font-size-small);\n    }\n\n    .guest-gallery-page .sparkle-image {\n        left: 41px !important;\n        bottom: 21px !important;\n        right: inherit !important;\n        top: inherit !important;\n        width: 60px !important;\n    }\n\n    .guest-gallery-page .header-image-anim img,\n    .guest-gallery-page .carousel-image {\n        width: 175px !important;\n    }\n\n    .guest-gallery-page .header-image-anim {\n        position: absolute !important;\n        bottom: 0 !important;\n        right: 20px !important;\n    }\n}\n\n@media (max-width: 375px) {\n    .guest-gallery-page .guest-hero-title {\n        font-size: var(--font-size-large);\n        margin-bottom: 11px;\n    }\n\n    .guest-gallery-page .guest-hero-subtitle {\n        font-size: var(--font-x-size-small);\n    }\n\n    .guest-gallery-page .sparkle-image {\n        left: 41px !important;\n        bottom: 21px !important;\n        right: inherit !important;\n        top: inherit !important;\n        width: 60px !important;\n    }\n\n    .guest-gallery-page .header-image-anim img,\n    .guest-gallery-page .carousel-image {\n        width: 200px !important;\n    }\n\n    .guest-gallery-page .header-image-anim {\n        position: absolute !important;\n        bottom: 0 !important;\n        right: 20px !important;\n    }\n}\n\n@media (max-width: 360px) {\n    .guest-gallery-page .guest-hero-title {\n        font-size: var(--font-size-large);\n        margin-bottom: 11px;\n    }\n\n    .guest-gallery-page .guest-hero-subtitle {\n        font-size: var(--font-x-size-small);\n    }\n\n    .guest-gallery-page .sparkle-image {\n        left: 41px !important;\n        bottom: 21px !important;\n        right: inherit !important;\n        top: inherit !important;\n        width: 60px !important;\n    }\n\n    .guest-gallery-page .header-image-anim img,\n    .guest-gallery-page .carousel-image {\n        width: 162px !important;\n    }\n\n    .guest-gallery-page .header-image-anim {\n        position: absolute !important;\n        bottom: 0 !important;\n        right: 20px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
